import React from "react";
import { Helmet } from "react-helmet";
import "../css/TermsConditions.css";

const TermsConditions = () => {
  return (
    <div>
      <Helmet>
        <title>Rising Cab Service | Terms & Conditions</title>
        <meta
          name="description"
          content="Terms & Conditions for Rising Cab Services including local rides, airport transfers, outstation trips, rentals, and corporate travel."
        />
      </Helmet>

      {/* Breadcrumb */}
      <div
        className="breadcumb-wrapper"
        style={{
          backgroundImage: "url('/img/bg/breadcrumb-bg.jpg')",
          position: "relative",
        }}
      >
        <div
          style={{
            position: "absolute",
            inset: 0,
            backgroundColor: "rgba(0,0,0,0.3)",
            zIndex: 1,
          }}
        ></div>

        <div className="container" style={{ position: "relative", zIndex: 2 }}>
          <div className="breadcumb-content">
            <h1 className="breadcumb-title">Terms & Conditions</h1>
          </div>
        </div>
      </div>

      {/* Terms Section */}
      <section className="terms-section">
        <div className="container">
          <div className="row g-0">

            <img src="/images/term.png" alt="Terms Rising Cab Service" />

            <div className="col-md-12">
              <div className="terms-content">

                <p>
                  <b className="highlight">1. Booking Confirmation:</b>
                  <br />
                  All bookings with Rising Cab Service are subject to vehicle availability.
                  A booking is confirmed only after receiving confirmation from our system or support team.
                </p>

                <p>
                  <b className="highlight">2. Service Usage:</b>
                  <br />
                  Rising Cab Services are strictly for passenger transportation.
                  Carrying illegal, hazardous, or restricted items is not allowed.
                </p>

                <p>
                  <b className="highlight">3. Payment Policy:</b>
                  <br />
                  Payments can be made via UPI, cards, net banking, wallets, or cash.
                  Advance payment may be required for airport, outstation, or corporate bookings.
                </p>

                <p>
                  <b className="highlight">4. Cancellation & Rescheduling:</b>
                  <br />
                  Cancellations should be made as early as possible.
                  Charges may vary based on timing and booking type.
                </p>

                <p>
                  <b className="highlight">5. Customer Responsibility:</b>
                  <br />
                  Customers must provide correct pickup/drop details and contact information.
                  Incorrect details may lead to extra charges or delays.
                </p>

                <p>
                  <b className="highlight">6. Seating & Luggage:</b>
                  <br />
                  Passengers must not exceed vehicle seating capacity.
                  Extra luggage may require a larger vehicle or additional charges.
                </p>

                <p>
                  <b className="highlight">7. Driver Duty Hours:</b>
                  <br />
                  Driver working hours follow transport regulations.
                  Long trips may include additional driver allowances.
                </p>

                <p>
                  <b className="highlight">8. Safety Guidelines:</b>
                  <br />
                  Passengers must follow safety instructions and avoid damaging the vehicle.
                </p>

                <p>
                  <b className="highlight">9. Right to Refuse Service:</b>
                  <br />
                  Rising Cab Service reserves the right to refuse service in case of unsafe,
                  abusive, or illegal behavior.
                </p>

                <p>
                  <b className="highlight">10. Fare Policy:</b>
                  <br />
                  Fare estimates may change based on tolls, parking, waiting time,
                  route changes, or additional requests.
                </p>

                <p>
                  <b className="highlight">11. Jurisdiction:</b>
                  <br />
                  Any disputes will be handled under the jurisdiction of Pune, Maharashtra.
                </p>

                {/* Rental Policy */}
                <h3>Rental Policy</h3>

                <p>
                  <b className="highlight">Services Offered:</b>
                  <br />
                  Rising Cab Service provides local rides, airport transfers, outstation trips,
                  corporate travel, rentals, and customized ride solutions.
                </p>

                <p>
                  <b className="highlight">Vehicle Allocation:</b>
                  <br />
                  Vehicles are assigned based on availability. Equivalent or upgraded
                  vehicles may be provided if required.
                </p>

                <p>
                  <b className="highlight">Toll, Parking & Taxes:</b>
                  <br />
                  All tolls, parking fees, and state taxes are payable by the customer
                  unless included in the package.
                </p>

                <p>
                  <b className="highlight">Night Charges:</b>
                  <br />
                  Additional charges may apply for rides during late-night hours.
                </p>

                {/* Refund Policy */}
                <h3>Refund Policy</h3>

                <p>
                  <b className="highlight">Refund Eligibility:</b>
                  <br />
                  Refunds depend on cancellation time and service type.
                </p>

                <p>
                  <b className="highlight">Processing Time:</b>
                  <br />
                  Approved refunds are processed within 5–7 business days.
                </p>

                <p>
                  <b className="highlight">Non-Refundable Charges:</b>
                  <br />
                  Convenience fees and certain offers may be non-refundable.
                </p>

                <p>
                  <b className="highlight">No-Show Policy:</b>
                  <br />
                  No refunds are provided for missed pickups or no-shows.
                </p>

              </div>
            </div>
          </div>

          {/* Contact Info */}
          <div className="contact-info">
            <h2>Contact Rising Cab Service</h2>

            <p>
              For booking support or queries, contact Rising Cab Service:
            </p>

            <ul>
              <li>
                <b>Phone:</b>{" "}
                <a href="tel:+919272511548">+91 9272511548</a>
              </li>

              <li>
                <b>Email:</b>{" "}
                <a href="mailto:booking@risingcabservice.com">
                  booking@risingcabservice.com
                </a>
              </li>

               <li>
                <b>Address:</b>
                <br />
                Rising Cab Services,<br />
                A Unit of Atithya Dining LLP,<br /> 901, 902 Deron Height,<br /> Baner Rd, Above Ranka Jewelers, <br />Pune, Maharashtra - 411069
              </li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TermsConditions;